import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "data-testid": "urgent-delivery-monitor-relabel-tab-root",
  class: "pt-4"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center pb-4" }
const _hoisted_3 = { class: "flex flex-row items-center gap-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-2 justify-end"
}
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = {
  key: 0,
  "data-testid": "urgent-delivery-monitor-relabel-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_UrgentRelabelFilter = _resolveComponent("UrgentRelabelFilter")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Search, {
          "data-testid": "urgent-delivery-monitor-relabel-search",
          placeholder: _ctx.$t('urgentRelabel.searchPlaceholder'),
          value: _ctx.parameters.search,
          onInput: _ctx.onSearch,
          onClear: _ctx.clearSearch,
          customMargin: "mr-0"
        }, null, 8, ["placeholder", "value", "onInput", "onClear"]),
        _createVNode(_component_UrgentRelabelFilter, {
          currentParameters: _ctx.parameters,
          onApply: _ctx.onApplyFilter,
          onReset: _ctx.onResetFilter
        }, null, 8, ["currentParameters", "onApply", "onReset"])
      ]),
      (_ctx.hasActions)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_lp_button, {
              "data-testid": "urgent-delivery-monitor-relabel-download",
              "icon-left": "download-new",
              iconV2: "",
              title: _ctx.$t('urgentRelabel.download'),
              textColor: "red-lp-2400",
              outline: "",
              small: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDownload()))
            }, null, 8, ["title"]),
            _createVNode(_component_lp_button, {
              "data-testid": "urgent-delivery-monitor-relabel-print-all",
              title: _ctx.$t('urgentRelabel.printAll'),
              iconV2: "",
              "icon-left": "printer",
              small: "",
              color: "red-lp-2400",
              iconColor: "white",
              textColor: "white",
              iconGroupHoverColor: "text-white",
              textColorHover: "white",
              onClick: _cache[2] || (_cache[2] = ($event) => _ctx.openPrintMenu($event))
            }, null, 8, ["title"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "printMenu",
      appendTo: "body"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.printSizes, (size) => {
            return (_openBlock(), _createBlock(_component_lp_button, {
              textColor: "black-lp-300",
              "icon-left": "printer",
              iconV2: "",
              key: size,
              flat: "",
              title: _ctx.$t('urgentRelabel.printSize', { size }),
              onClick: ($event: any) => (_ctx.onPrint(size)),
              "data-testid": 
            `urgent-delivery-monitor-relabel-print-${
              _ctx.printSttNo ? 'row' : 'all'
            }-${size.toLowerCase()}`
          
            }, null, 8, ["title", "onClick", "data-testid"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 512),
    (
        _ctx.listData.data.length || _ctx.apiListData.loading || _ctx.apiListData.errorType
      )
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_TableV2, {
            pagination: _ctx.listData.pagination,
            "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listData.pagination = $event)),
            loading: _ctx.apiListData.loading,
            columns: _ctx.tableColumns,
            data: _ctx.listData.data,
            paginationStyle: "v3",
            onRequest: _ctx.fetchList,
            onSort: _ctx.onSort,
            onTryAgain: _ctx.fetchList,
            errorCause: _ctx.apiListData.errorType,
            sortBy: _ctx.parameters.orderBy,
            sortDirection: _ctx.parameters.sort,
            isBorderOnHeadBgWhite: "",
            bgHeader: "bg-white border-t",
            paginationV3PaddingVertical: "pt-1 pb-3",
            customClassPagination: "absolute w-full bottom-2 right-0 left-0 -mb-4 px-8",
            isNoPaddingBottom: "",
            borderTop: false,
            pinnedSubstractHeight: "255px",
            isRightFreeze: "",
            totalColumnFreeze: 1
          }, null, 8, ["pagination", "loading", "columns", "data", "onRequest", "onSort", "onTryAgain", "errorCause", "sortBy", "sortDirection"])
        ]))
      : _createCommentVNode("", true),
    (
        !_ctx.listData.data.length && !_ctx.apiListData.loading && !_ctx.apiListData.errorType
      )
      ? (_openBlock(), _createBlock(_component_EmptyState, {
          key: 1,
          "data-testid": "urgent-delivery-monitor-relabel-empty-state",
          customHeaderMessage: _ctx.emptyStateData.headerMessage,
          customMessage: _ctx.emptyStateData.message,
          icon: _ctx.emptyStateData.icon
        }, null, 8, ["customHeaderMessage", "customMessage", "icon"]))
      : _createCommentVNode("", true)
  ]))
}